import React from 'react';
import { connect } from 'react-redux';

import { clearApiResponseInfo } from '../store/slices/apiResponseInfoSlice';

const Unauthorized = (props) => (
  <div>
    <h1>Unauthorized Access to API</h1>
    <div>You appear to be trying to access</div>
    <div style={{ marginLeft: '12px' }}>{props.apiResponseInfo.callDescrip}</div>
    <div>without the necessary permission level.</div>
  </div>
);

const mapStateToProps = (state) => ({ apiResponseInfo: state.apiResponseInfo });
export default connect(mapStateToProps, { clearApiResponseInfo })(Unauthorized);
